/**
 *
 * @param src 传递过来的url
 * @param publicUrlapi 二级路径api变量
 * @param publicUrl 二级路径前端静态资源变量
 */
export const getSecondPathUrl = (src: any) => {
  // 默认全局的
  const publicUrl = window.publicUrlstatic || window.publicUrl || '';
  const publicUrlapi = window.publicUrlapi || window.publicUrl || '';
  // 传递过来的二级路径变量  二级路径api变量均为空的时候不进行处理
  if (!publicUrlapi && !publicUrl) return src;
  // api 前缀的正则匹配
  const apiReg = /^\/(api|sapi|papi)/;
  // 二级路径静态资源的匹配
  const publicUrlReg = new RegExp(`^${publicUrl}`);
  // 后端二级路径api匹配
  const publicUrlapiReg = new RegExp(`^${publicUrlapi}`);
  // 相对地址的匹配
  const regSingle = /^\//;

  if (src.match(apiReg)) {
    // 情况1  对应的url    /api/sapi/api开头的情况
    // 根据api接口获取到对应的模块标识
    const name = getNameFromUrl(src);
    let apiPrefix;
    if (name) {
      apiPrefix = window[`apiUrlweapp${name}`] || window.publicUrlapi || window.publicUrl || ''; // 处理二级路径
    } else if (publicUrlapi) {
      // 匹配不出模块名称的场景下 但是存在二级路径api变量的场景
      apiPrefix = publicUrlapi;
    }
    return apiPrefix + src;
  } else if (publicUrl && src.match(publicUrlReg)) {
    // 情况2 已经携带前端二级路径的地址不处理
    return src;
  } else if (publicUrlapi && src.match(publicUrlapiReg)) {
    // 情况3 已经携带后端api变量的地址不处理
    return src;
  } else if (publicUrl && !src.match(publicUrlReg) && src.match(regSingle)) {
    // 情况4 存在前端变量 并且对应的链接以 /开头的非api请求 不携带二级路径变量
    return publicUrl + src;
  } else if (publicUrlapi && !src.match(publicUrlapiReg) && src.match(regSingle)) {
    // 情况5  存在后端api变量 并且对应连接诶以 / 开头的非后端路径 不携带二级路径api变量
    return publicUrlapi + src;
  } else {
    return src;
  }
};

/**
 * @param {string} url 请求地址
 *
 * @description 匹配 url 数据格式，并从 url 中获取模块标识
 *
 * API 匹配规则： /^\/p?api(\/app)?(\/bs)?\/[^/?]+/
 *
 * 示例：
 *
 * '/api/bs/test?v=1' => 'test'
 *
 * '/api/app/bs/test?v=1' => 'test'
 *
 * '/papi/bs/test?v=1' => 'test'
 *
 * '/papi/app/bs/test?v=1' => 'test'
 *
 * '/api/task/test?v=1' => 'task'
 *
 * '/api/app/task/test?v=1' => 'task'
 *
 * '/papi/task/test?v=1' => 'task'
 *
 * '/papi/app/task/test?v=1' => 'task'
 */
export function getNameFromUrl(url: string) {
  let name: string = '';

  const matchUrl: any = url.match(/^\/p?api(\/app)?(\/bs)?\/[^/?]+/);
  if (matchUrl) {
    // 截取 api 中模块的标识，只能处理一级标识
    name = matchUrl[0].replace(/^\/p?api(\/app)?(\/bs)?\//, () => '');
  }
  return name;
}
